'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recursionSearchParent = recursionSearchParent;
exports.getParent = getParent;
exports.getParentPath = getParentPath;
exports.getAllParents = getAllParents;
exports.getChildrenById = getChildrenById;
exports.recursionSearch = recursionSearch;

var _lodash = require('lodash');

/**
 * 递归遍历树，获取指定id节点的父节点
 * @param {*} root schema调用根结点
 * @param {*} id 节点的id
 * @param {*} parentNode 父节点
 * @returns 父节点
 */
function recursionSearchParent(root, id, parentNode) {
  var node = void 0;
  for (var i = 0; i < root.length; i++) {
    node = root[i];

    if (node.id === id) {
      return parentNode;
    }

    if (node.children && (node = recursionSearchParent(node.children, id, node))) {
      return node;
    }
  }
  return null;
}
/**
 * 获取schema中指定节点(id)的父节点
 * 注意1：schema是标准透传的schema，可以通过在this.props.context中获取
 * 注意2:
 * @param {*} schema
 * @param {*} id 节点的id
 * @returns
 */
/**
 * 1. 对schema的操作，本质上是对tree的操作。不取名为schema.js是怕引起误解，如果后续有强要求的schema的操作，可以改名为schema.js
 * 2. 在引用前，最好看下已有的使用范例
 * 3. 修改内容一定要有注释，便于后人查看
 */
function getParent(schema, id) {
  var root = (0, _lodash.get)(schema, 'pages[0].layout', {});
  var child = (0, _lodash.get)(root, 'children', []);

  return recursionSearchParent(child, id, root);
}
/**
 * 获取schema中指定节点(id)的所有父节点
 * @param {*} id
 * @param {*} root 根节点
 * @returns 所有父节点的数组
 */
function getParentPath(id, root) {
  var path = [];

  function helper(node) {
    for (var i = 0; i < node.length; i++) {
      var item = node[i];

      if (item.id === id) {
        return true;
      }

      if (item.children && helper(item.children)) {
        path.push(item);
        return true;
      }
    }
  }
  // 根节点的子元素
  helper(root.children);
  return path;
}
/**
 * 获取schema中指定节点(id)的所有父节点
 * 注意1：schema是标准透传的schema，可以通过在this.props.context中获取
 * 注意2:
 * @param {*} schema
 * @param {*} id 节点的id
 * @returns 所有父节点的数组
 */
function getAllParents(schema, id) {
  var root = (0, _lodash.get)(schema, 'pages[0].layout', {});

  return getParentPath(id, root);
}

function getChildrenById(schema, id, key) {
  return recursionSearch(schema.children, id, key);
}
// update: node[key] == id为兼容3300 == ‘3300’
function recursionSearch(root, id) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';

  var node = void 0;
  for (var i = 0; i < root.length; i++) {
    node = root[i];

    if (node[key] == id) {
      return node;
    }

    if (node.children && (node = recursionSearch(node.children, id, key))) {
      return node;
    }
  }
  return null;
}